/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

import { areTitleWordsCapitalized } from 'src/shared/app/locale/settings/localeSettings';
import { capitalize, capitalizeWords } from 'src/shared/core/util/stringUtil';

type Props = {
  children: string,
};

const DocumentTitle = ({ children }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const { locale } = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <React.Fragment>
      <Helmet>
        <title>
          {areTitleWordsCapitalized(locale)
            ? capitalizeWords(children)
            : capitalize(children)}
        </title>
      </Helmet>
    </React.Fragment>
  );
};

export default compose(React.memo)(DocumentTitle);
